import { useCTW } from '@ctw/shared/context/ctw-context';
import { Telemetry } from '@ctw/shared/context/telemetry';
import { type PropsWithChildren, useEffect } from 'react';

interface TelemetryProviderProps extends PropsWithChildren {}

export const TelemetryInitializer = ({ children }: TelemetryProviderProps) => {
  const { requestContext } = useCTW();

  // Initialize telemetry in the background. Events fired before initialization
  // completes are buffered in Telemetry.deferredEvents and replayed via
  // flushDeferredEvents() once init finishes — no events are lost.
  useEffect(() => {
    Telemetry.init({ requestContext }).catch((error) => {
      // Telemetry.init() handles SDK failures internally and still flushes
      // deferred events, so reaching here indicates an unexpected failure.
      Telemetry.logger.error('Telemetry', 'Initialization promise rejected', { error });
    });
  }, [requestContext]);

  return children;
};
